import Main from '@/components/Main'

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/main.js